module.exports = __webpack_public_path__ + "img/marker.1011be77.png";